import { TipoEmpleadoEnumChoice } from "@/shared";
import { useCategoriaProductoStore, userPromocionesStore } from "@/store/erp";
import { useEmpleadoStore } from "@/store/erp/empleado";
import { usePaymentMethodsStore } from "@/store/erp/system-settings/payment-methods";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useTypeInstalation } from "@/store/erp/system-settings/type-instalation";
import { useEffect } from "react";
import { Outlet } from "react-router-dom"

const VentaCorporativaModule = () => {
  const getPromociones = userPromocionesStore(s => s.getPromociones);
  const getpaymentMethodsFilterPaging = usePaymentMethodsStore(s => s.getpaymentMethodsFilterPaging);
  const getPlans = usePlanStore(s => s.getPlans);
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);
  const getEmpleadoVenta = useEmpleadoStore(s => s.getEmpleado);
  const getCategoriaProducto = useCategoriaProductoStore(s => s.getCategoriaProducto);
  const getPlansCorporativos = usePlanStore(s => s.getPlansCorporativos);

  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getPromociones(),
        getPlans({ page_size: 300 }),
        getTypeInstalation({ page_size: 600 }),
        getpaymentMethodsFilterPaging({
          page_size: 600,
          aplica_corporativo: true
        }),
        getEmpleadoVenta({
          tipo_empleado: TipoEmpleadoEnumChoice.VENDEDOR,
          page_size: 10
        }),
        getCategoriaProducto({ page_size: 600 }),
        getPlansCorporativos({ page_size: 300 }),
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return (
    <Outlet />
  );
}
export default VentaCorporativaModule
